export default {
  async getMediaStream() {
    this.setStreamConfig();

    const stream = new MediaStream();

    for (const track of this.localTracks) {
      // For video track with active blur, use the processed track from VB processor
      if (track === this.localVideoTrack && this.vbPipelined && this.videoEffect !== 'none' && this.vbProcessor) {
        const processedTrack = await this.vbProcessor.getProcessedTrack();
        if (processedTrack) {
          stream.addTrack(processedTrack);
          continue;
        }
      }
      stream.addTrack(track._mediaStreamTrack);
    }

    return { stream };
  }
}
